import ShippingAddress from './shipping-address'

export default ShippingAddress
